import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { AppdataService } from 'src/app/services/services/appdata.service';
import { LoginserviceService } from 'src/app/services/services/loginservice.service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationDialogService } from '../confirmation-dialog/confirmation-dialog.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AddassetpopupComponent } from '../generalpopup/addassetpopup/addassetpopup.component';

@Component({
  selector: 'app-empasset',
  templateUrl: './empasset.component.html',
  styleUrls: ['./empasset.component.css']
})
export class EmpassetComponent implements OnInit {


  constructor(private toastr: ToastrService,private appService: AppdataService,
    private loginService:LoginserviceService,private activeModal: NgbActiveModal,private confirmationDialogService: ConfirmationDialogService,
    private productFindService: NgbModal,) { }

//Save Validation
submitted:boolean;
successfully:boolean;

empassetform=new FormGroup({
  assetid:new FormControl(0,Validators.required),          
  givendt:new FormControl(null),   
  expertreturndt:new FormControl(null),   
  returndt:new FormControl(null),   
  descr:new FormControl(''),   
});
  
  
empassetreturnform=new FormGroup({  
  returndt:new FormControl(null,Validators.required),   
  descr:new FormControl(''),   
});

//Edit Get Values
assetColl:any=[];

@Input() empassetid:any=0;
@Input() assetid:any=null;
@Input() givendt:any=null;
@Input() expertreturndt:any=null;
@Input() returndt:any=null;
@Input() descr:any=null;

  
@Input() formtype: any = "";
  
@Output() emitData = new EventEmitter();


ngOnInit() {

  this.empassetform.reset();
  this.empassetreturnform.reset();
  this.fnInitializeFormGroup(); 
  this.fngetAsset();
}


fnInitializeFormGroup(){
  this.empassetform.setValue({
    assetid: this.assetid,
    givendt: new Date(),
    expertreturndt: new Date(),
    returndt: this.returndt,
    descr: this.descr,
  });


  this.empassetreturnform.setValue({   
    returndt: this.returndt,
    descr: this.descr,
  });
}

//Get 
fngetAsset() {
  
  var data = {
  'assetid':this.assetid,
  'companyid':this.loginService.fnGetCompanyId()          
  }
  this.appService.getAssetAvailable(data)
  .subscribe(
  (res)=>{                
  if(res.json().status===200){  
  this.assetColl=res.json().result;     
  }
  else {
  this.loginService.fnAPIError(res.json())
  }

  },
  (err)=>{          
  this.toastr.error('Error', err);
  })
}

fnSaveBtnClick(){
try{
  this.submitted=true;
  this.successfully = false;
  if (this.formtype === '') {
    this.empassetform.controls['expertreturndt'].setErrors(null);
      //Validate
      if (this.empassetform.valid) {
              
        if(this.loginService.fnCompareDateValidation(this.empassetform.get('expertreturndt').value,this.empassetform.get('givendt').value)){
          this.empassetform.controls['expertreturndt'].setErrors({'notfound': true});
          return
        }
            
      const index = this.assetColl.findIndex(sku => sku.assetid === this.empassetform.get('assetid').value); 

      //Check
      var data = {
        empassetid: this.empassetid,                      
        assetid:this.empassetform.get('assetid').value, 
        assetname:this.assetColl[index].assetname,     
        givendt:this.empassetform.get('givendt').value,   
        expertreturndt:this.empassetform.get('expertreturndt').value,   
        returndt:this.empassetform.get('returndt').value,   
        descr:this.empassetform.get('descr').value,                     
      }
      this.emitData.emit(data);  
      this.activeModal.close(true);  

    }
  }
  else if(this.formtype === 'RETURN') {
    //Validate
    if(this.empassetreturnform.valid){
                  //Check
      var data1 = {   
        empassetid:this.empassetid,
        isreturn:true,
        returndt:this.empassetreturnform.get('returndt').value,   
        descr: this.empassetreturnform.get('descr').value,
        modifiedby:this.loginService.fnGetModUserId()
      }
      this.emitData.emit(data1);  
      this.activeModal.close(true);  

    }
  }
    

}catch(ex){
this.fnShowErrorMsg(ex);
}
}

//AddDeduction
private fnAddAsset() {

  const modalRef = this.productFindService.open(AddassetpopupComponent, { size: <any>'xxl' });

  modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

    this.fngetAsset();

    if (receivedEntry > 0) {
      this.empassetform.patchValue({ assetid: receivedEntry })
    }
  });

}


public decline() {
this.activeModal.close(false);
}


private  fnShowErrorMsg(ex){
this.toastr.warning('Internal Error', ex);       
}




}
